import { CommonModule, NgClass } from '@angular/common';
import { Component, computed, input, OnInit, output, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StaffData } from '@interfaces';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { KENDO_ICONS, SVGIcon } from '@progress/kendo-angular-icons';
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { KENDO_AVATAR } from '@progress/kendo-angular-layout';
import { userIcon } from '@progress/kendo-svg-icons';
@Component({
	selector: 'staff-selector-widget',
	standalone: true,
	imports: [CommonModule, KENDO_DROPDOWNS, KENDO_LABELS, KENDO_ICONS, KENDO_AVATAR, FormsModule, NgClass],
	templateUrl: './staff-selector.widget.html',
	encapsulation: ViewEncapsulation.None,
})
export class StaffSelectorWidget implements OnInit {

	public valueChange = output<({ staffId?: number, personId?: number, fullName?: string } | undefined)>();
	public readonly data = input.required<StaffData[]>();
	public readonly userId = input.required<number>();
	public readonly disabled = input<boolean>(false);
	public readonly required = input<boolean>(true);
	public value = input<{ staffId?: number, personId?: number, fullName?: string } | undefined>(undefined);
	public readonly userSvg: SVGIcon = userIcon;

	public readonly errorToShow = computed(() => {
		if (this.required() && !this.selectedValue())
			return 'Required Field'
		return ''
	});
	public selectedValue = signal<StaffData | undefined>(undefined);

	ngOnInit() {
		this.setInitValue();
	}

	private setInitValue() {
		const val = this.value();
		const data = this.data();
		if (!val || (val.staffId === undefined && val.personId === undefined && val.fullName === undefined)) {
			this.selectedValue.set(data.find(t => t.staffId === this.userId()));
		} else {
			this.selectedValue.set(data.find(t => (val.staffId && t.staffId === val.staffId) ||
				(val.personId && t.personId === val.personId) ||
				(val.fullName && t.fullName === val.fullName)));
		}

		this.emitValueChanged();
	}

	public onValueChange(staff: StaffData) {
		this.selectedValue.set(staff);
		this.emitValueChanged();
	}

	private emitValueChanged() {
		const selectedValue = this.selectedValue();
		if (selectedValue) {
			this.valueChange.emit({
				staffId: selectedValue.staffId,
				personId: selectedValue.personId,
				fullName: selectedValue.fullName
			});
		} else {
			this.valueChange.emit(undefined);
		}
	}
}